import React from "react";
import { Link, useLocation } from "react-router-dom";
import { carryParams } from "../nflToolFilters";

export const NFL_TOOLS = [
  { key: "stat-engine", label: "Stat Engine", path: "/tools/nfl-engine" },
  { key: "matchup-advantage", label: "Matchup Advantage", path: "/tools/matchup-advantage" },
  { key: "redzone", label: "Redzone", path: "/tools/redzone-advantage" },
  { key: "scouting-report", label: "Scouting Report", path: "/tools/scouting-report" },
  { key: "projections", label: "Projections", path: "/tools/nfl/projections" },
];

export default function ToolSwitcher({ active }) {
  const { search } = useLocation();
  const carried = carryParams(search);

  return (
    <nav className="nfl-switcher" aria-label="NFL tools">
      <div className="nfl-inner nfl-switcher-row">
        <span className="nfl-switcher-family nfl-display" aria-hidden="true">
          NFL
        </span>
        {NFL_TOOLS.map((tool) => {
          const isActive = tool.key === active;
          return (
            <Link
              key={tool.key}
              to={{ pathname: tool.path, search: carried }}
              className={"nfl-switcher-link" + (isActive ? " is-active" : "")}
              aria-current={isActive ? "page" : undefined}
            >
              {tool.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
